import { render } from "./InternView.vue?vue&type=template&id=08f8f036"
import script from "./InternView.vue?vue&type=script&lang=js"
export * from "./InternView.vue?vue&type=script&lang=js"

import "./InternView.vue?vue&type=style&index=0&id=08f8f036&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__